import { environment } from '$env';
import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-login-header',
  styleUrls: ['./login-header.component.scss'],
  templateUrl: './login-header.component.html',

  imports: [RouterLink, ButtonModule],
})
export class LoginHeaderComponent {
  private readonly location = inject(Location);
  public appName = environment.properties.appName;

  public close() {
    this.location.back();
  }
}
